/**
 * Hosted login via authorization code + PKCE (docs/decisions/2026-09-12-auth-cognito-…).
 * Tokens live in sessionStorage for this tab only; the access token carries workspace_id.
 */
import { UserManager, WebStorageStateStore, type User } from "oidc-client-ts";
import type { AppConfig } from "../config";

export type Session = { accessToken: string; email: string };

export function createUserManager(cfg: AppConfig, origin: string): UserManager {
  return new UserManager({
    authority: cfg.issuer,
    client_id: cfg.clientId,
    redirect_uri: `${origin}/callback`,
    post_logout_redirect_uri: origin,
    response_type: "code",
    scope: "openid email profile",
    userStore: new WebStorageStateStore({ store: window.sessionStorage }),
    automaticSilentRenew: true,
  });
}

export function logoutUrl(cfg: AppConfig, origin: string): string {
  return `${cfg.loginDomain}/logout?client_id=${cfg.clientId}&logout_uri=${encodeURIComponent(origin)}`;
}

export function sessionFrom(user: User | null): Session | null {
  if (!user || user.expired) return null;
  const email = typeof user.profile.email === "string" ? user.profile.email : "";
  return { accessToken: user.access_token, email };
}
